import { isValid } from "date-fns";

const checkIfDateIsValid = (date) => {
  return date && isValid(new Date(date)) && !isNaN(new Date(date).valueOf())
    ? true
    : false;
};

export default checkIfDateIsValid;
